import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { FuncionalidadesService } from '../../../services/funcionalidades.service';
import { FuncionalidadRolesService } from '../../../services/funcionalidad-roles.service';
import { RolesService } from '../../../services/roles.service';
import { Funcionalidades } from '../../../models/funcionalidades.model';
import { RolesSingle } from '../../../models/rolesSingle.model';
import { FuncionalidadRolesFull } from '../../../models/funcionalidadRolesFull.model';
import { FuncionalidadRoles } from '../../../models/funcionalidadRoles.model';
import { Router, ActivatedRoute } from '@angular/router';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-crear-func',
  templateUrl: './crear-editar-func.component.html',
  styleUrls: ['./crear-editar-func.component.css']
})
export class CrearFuncComponent implements OnInit {

  titulo!: string;
  datoTabla!: string;
  mensaje = 'Campo obligatorio';
  mensajeRoles = 'Debe seleccionar al menos un rol';
  codigoExistente = 'El código de la funcionalidad ya existe';
  funcExistente = 'El nombre de la funcionalidad ya existe';
  errorGuardado = 'No se pudo hacer las asignaciones de los roles a la funcionalidad seleccionada';
  resultado: any[] = [];
  cadena: string[] = [];
  list_roles_origen: any;
  list_roles_destino: any;
  list_asignaciones: FuncionalidadRoles[] = [];
  tablaPrevisualizar!: FuncionalidadRolesFull;
  guardarAsignaciones!: FuncionalidadRoles;
  rolSolo!: RolesSingle;
  rolOrigen: RolesSingle | undefined;
  rolDestino: RolesSingle | undefined;
  formulario!: FormGroup;
  indiceRolOrigen: string | undefined;
  indiceRolDestino: string | undefined;
  funcionalidad: Funcionalidades | undefined;
  nombre: string | undefined;
  nombreAplicacion: string | undefined
  sigla: string | undefined
  url: string | undefined
  cadenaRoles = '';
  correcto = false;
  fecha!: Date;
  formato!: string;
  codigo: string | undefined;
  respuesta:any
  aplicativo:any
  aplicativoObj:any = {
    nombreAplicativo: '',
    urlAplicativo: '',
    siglaAplicativo: '',
    idRoles: [],
    roles: '',
  }

   categorias:any =[];

  index_destino:number=-1;


  constructor(private funcionalidadesService: FuncionalidadesService,
              private funcionalidadRolesService: FuncionalidadRolesService,
              private rolesService: RolesService,
              private fb: FormBuilder,
              private router: Router,
              private route: ActivatedRoute)
  {

    this.codigo = this.route.snapshot.paramMap.get('codigo')?.toString();

    this.crearFormulario();
  }

  ngOnInit(): void {
    this.cargarRoles();
    if (this.codigo != undefined) {
      this.titulo = 'Editar aplicativo';
      this.datoTabla = 'editar';
      this.funcionalidadRolesService.traerFuncionalidadRolesById(this.codigo+"")
      .subscribe(resp => {
        this.respuesta = resp;
        this.aplicativo = this.respuesta.data[0]
        this.cargarFormulario();
      });
    } else {
      this.titulo = 'Crear aplicativo';
      this.datoTabla = 'crear';
    }

  }

  get nombreObligatorio(): boolean{
    return this.formulario.get('Nombre')?.touched && this.formulario.get('Nombre')?.errors?.['required'];
  }

  get codigoTramiteObligatorio(): boolean{
    return this.formulario.get('CodigoTramite')?.touched && this.formulario.get('CodigoTramite')?.errors?.['required'];
  }

  get siglaObligatorio(): boolean{
    return this.formulario.get('Sigla')?.touched && this.formulario.get('Sigla')?.errors?.['required'];
  }

  crearFormulario(): void{
    this.formulario = this.fb.group({
      //CodigoTramite: ['', Validators.required],
      Nombre: ['', Validators.required],
      Url:[],
      Sigla: ['', Validators.required],
    });
  }

  //Carga la información cuando se requiere la operación de editar
  cargarFormulario(): void {
    let idRoles:string[];
    let roles:any[]=[];
    let rol:any
    //this.list_roles_destino=[]
    this.formulario.controls['Nombre'].setValue(this.aplicativo.nombreAplicativo);
    this.formulario.controls['Sigla'].setValue(this.aplicativo.siglaAplicativo);
    this.formulario.controls['Url'].setValue(this.aplicativo.urlAplicativo);
    this.nombreAplicacion = this.aplicativo.nombreAplicativo
    this.url = this.aplicativo.urlAplicativo
    this.sigla = this.aplicativo.siglaAplicativo
    idRoles = this.aplicativo.idRoles
    roles = this.aplicativo.listaRoles;

console.log(this.list_roles_destino);
    console.log(roles);
    for(let i = 0;i<roles.length;i++){
      rol = {
            idRole: '',
            displayName:''
          }
      rol.idRole = roles[i].idRol
      rol.displayName = roles[i].nombreRol
      console.log(rol)
      this.list_roles_destino[i]=rol
      this.cadena.push(rol.displayName);
    }
  }

  cargarRoles(): void{
    this.rolesService.traerRoles()
    .subscribe(resp => {
      this.respuesta = resp;
      this.list_roles_origen = this.respuesta.data;
      this.list_roles_destino = []
    });
  }
  //Caja para selección de roles disponibles
  seleccionRolOrigen(e: any, i: number): void{
    this.rolOrigen = this.list_roles_origen[i]
    this.indiceRolOrigen = this.list_roles_origen[i].idRole;
  }

  //Caja para selección de roles seleccionados
  seleccionRolDestino(e: any, i: number): void{
    this.rolDestino = this.list_roles_destino[i];
    this.indiceRolDestino = this.list_roles_destino[i].idRole
    this.index_destino = i
  }

  agregarRol(): void{
    if (this.rolOrigen != undefined) {
      if (!this.cadena.includes(this.rolOrigen.displayName!)) {
        this.list_roles_destino.push(this.rolOrigen);
        this.cadena.push(this.rolOrigen.displayName!);
      }
      this.indiceRolOrigen = '';
      this.rolOrigen = undefined;
    }
  }

  quitarRol(): void{
    if (this.rolDestino != undefined) {
      this.list_roles_destino.splice(this.index_destino,1);
      this.cadena.splice(this.index_destino,1)
      this.indiceRolDestino = '';
      this.rolDestino = undefined;
    }
  }

  editar(): void{
    this.correcto = false;
    this.formulario.get('CodigoTramite')?.enable();
    this.formulario.get('Nombre')?.enable();
    this.cadenaRoles = '';
  }

  guardarAplicacion():void{
    let roles:any = []
    let cadenaRoles:string = ''

    console.log('nombre==>',this.nombreAplicacion, ' Sigla==>',this.sigla, ' url==>', this.url)

    if (this.nombreAplicacion != undefined && this.sigla != undefined && this.url != undefined) {
      if(this.list_roles_destino.length>0){
        this.list_roles_destino.forEach((item: { idRole: any; }) => {
          roles.push(item.idRole);
        });
        cadenaRoles = roles.toString()
        this.aplicativoObj = {
          nombreAplicativo: this.nombreAplicacion,
          urlAplicativo: this.url,
          siglaAplicativo: this.sigla,
          idRoles: roles,
          roles: cadenaRoles,
          idResponsable:JSON.parse(localStorage.getItem('currentUser')+"").userId
        }
        console.log(this.codigo);
        console.log(this.aplicativo);
        //Si existe código la operación es para actualizar
        if (this.codigo != undefined) {
          console.log('entro')
          this.aplicativoObj.idAplicativo = this.codigo
          this.aplicativoObj.codigoAplicativo = this.aplicativo.codigoAplicativo
          this.aplicativoObj.estado =  (this.aplicativo.estado =="Habilitado")+"";
          this.funcionalidadRolesService.actualizarFuncionalidadRoles(this.aplicativoObj)
          .subscribe(resp => {
            if (resp.data!=null) {
              let data = [
                {
                  name: "string",
                  defaultLabel: true,
                  labelId: 0
                }
              ]

              this.funcionalidadRolesService.ObtenerTramitesVentanilla(data)
                .subscribe(resp => {

                  let tramites=resp;
                  let tramiteencontrado=tramites.filter((item: { name: string; }) => item.name==this.aplicativo.nombreAplicativo);

                  if(tramiteencontrado.length>0)
                  {
                    this.funcionalidadRolesService.getPersonalidadAplicable()
                      .subscribe(respcategorias => {

                        let categoria=respcategorias.filter((item: { description: string; }) => item.description==tramiteencontrado[0].categoryName);
                        tramiteencontrado[0].name=this.nombreAplicacion;
                        tramiteencontrado[0].redirectUrl=this.url;
                        tramiteencontrado[0].paperworkCategoryId=categoria[0].id

                        let tramitemain = {
                          id: tramiteencontrado[0].idTramite,
                          codTramite: this.sigla,
                          nameTramite: this.nombreAplicacion,
                          estado: (this.aplicativo.estado =="Habilitado")
                        }
                    

                        this.funcionalidadRolesService.actualizarFuncionalidadVentanilla(tramiteencontrado[0].id,tramiteencontrado[0])
                          .subscribe(resp => {
                            this.funcionalidadRolesService.actualizarTramitesMainVentanilla(tramitemain)
                              .subscribe(resp => {

                                this.ventanaEmergenteExito();
                                this.router.navigateByUrl('funcionalidades');

                              });


                          });
                      });









                  }
                  else
                  {
                    this.ventanaEmergenteExito();
                    this.router.navigateByUrl('funcionalidades');
                  }

                });






            } else {
              this.ventanaEmergenteError(this.errorGuardado);
            }
          });
        }else{  //Si no existe el código se debe crear
          console.log('siguio')
          this.funcionalidadRolesService.guardarFuncionalidadRoles(this.aplicativoObj)
          .subscribe(resp => {
            if (resp.data!=null) {
              this.ventanaEmergenteExito();
              this.router.navigateByUrl('funcionalidades');
            } else {
              this.ventanaEmergenteError(this.errorGuardado);
            }
          });
        }
    }else{
        this.ventanaEmergenteError('Debe seleccionar al menos un rol');
      }
    }else{
      this.ventanaEmergenteError('Falta información, por favor complete el formulario');
    }
  }


  cancelar(): void{
    if (this.nombre != undefined) {
      this.router.navigateByUrl('funcionalidades');
    } else {
      this.router.navigateByUrl('principal');
    }
  }


  ventanaEmergenteError(mensaje: string): void{
    Swal.fire({
      title: 'Operación no exitosa',
      text: `${ mensaje }`,
      iconHtml: '<img src="assets/img/error.png" class="w-75 ms-2">',
      customClass: {
        icon: 'no-bordes',
        title: 'text-danger'
      },
      allowOutsideClick: false,
      showCloseButton: true,
      showConfirmButton: true,
      confirmButtonText: 'Aceptar',
      confirmButtonColor: '#0d6efd'
    });
  }

  ventanaEmergenteExito(): void{
    Swal.fire({
      title: 'Operación exitosa',
      iconHtml: '<img src="assets/img/success.png" class="w-75 ms-2">',
      customClass: {
        icon: 'no-bordes',
        title: 'text-success'
      },
      allowOutsideClick: false,
      showCloseButton: true,
      showConfirmButton: true,
      confirmButtonText: 'Aceptar',
      confirmButtonColor: '#0d6efd'
    });
  }
}
